import { createAction, props } from '@ngrx/store';

export const gotoDetails = createAction(
  '[Create ILClass Page] Select Go To Details',
  props<{ gotoDetails: boolean }>()
);
